export const SET_USER = "SET_USER";
export const USER_IS_LOADING = "USER_IS_LOADING";
export const USER_STATUS = "USER_STATUS";
export const FETCH_USER = "FETCH_USER";
export const GET_EVENTS = "GET_EVENTS";
export const NAVIGATION_LINKS = "NAVIGATION_LINKS";
export const PREFERENCES = "PREFERENCES";
export const DARK_MODE_PREFERENCE = "DARK_MODE_PREFERENCE";
export const EMERGENCY_ALERT = "EMERGENCY_ALERT";
export const Events = "EVENTS";
export const ADD_ITEM = "ADD_ITEM";

/* Export each action file below */
export * from "./Authentication/actions";
export * from "./Components/AppHeader";
export * from "./Components/EmergencyAlert/actions";
export * from "./util/dropdownconstants";
//export * from './Components/Requests/actions';
//export * from './Components/Navbar/actions'
